class AdvancedGallerySlider extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    // Prevent double init
    if (this.swiperInstance) return;

    // Wait until Swiper is available
    if (typeof Swiper === 'undefined') {
      console.error('Swiper not loaded');
      return;
    }

    this.initSwiper();
  }

  initSwiper() {
    this.swiperInstance = new Swiper(this, {
      slidesPerView: 1.25,
      spaceBetween: 16,
      loop: false,
      centeredSlides: false,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}

customElements.define('advanced-gallery-slider', AdvancedGallerySlider);
